import Vue from 'vue'
import App from './App'
import VueInject from './lib/v-inject'
import TmButton from './components/TmButton'
import TmSpinner from './components/TmSpinner'
import {
  Modal as VkModal,
  Button as VkButton,
  ModalConfirm as VkModalConfirm
} from 'vuikit'

Vue.directive('inject', VueInject)
Vue.component('AdminManager', App)
Vue.component('TmButton', TmButton)
Vue.component('TmSpinner', TmSpinner)
Vue.component('VkButton', VkButton)
Vue.component('VkModal', VkModal)
Vue.component('VkModalConfirm', VkModalConfirm)

// set up vue-resources
Vue.http.options.emulateHTTP = true
Vue.http.options.emulateJSON = true
Vue.http.interceptors.push({
  response: function (response) {
    if (response.data !== 'OK' && !Vue.util.isObject(response.data)) {
      response.status = 500
      response.ok = false
      response.data = {
        error: stripTags(response.data),
        message: `Something went wrong with that request. Please try again
          or contact our support for further assistance.`
      }
    }
    return response
  }
})

// http://phpjs.org/functions/strip_tags/
var stripTags = function (input, allowed) {
  allowed = (((allowed || '') + '')
    .toLowerCase()
    .match(/<[a-z][a-z0-9]*>/g) || [])
    .join('') // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
  let tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
  let commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi
  return input.replace(commentsAndPhpTags, '')
    .replace(tags, function ($0, $1) {
      return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''
    })
}



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/